module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-02-jp.3f05a56584ad347bb769b4fa982e9c4b.png";